module.exports = __webpack_public_path__ + "static/media/inclusion-social.6d0d333c.jpg";